import React from 'react';
import { StyleSheet, ActivityIndicator, Text } from 'react-native';
import FormField from 'ui/form/FormField';
import { Chip } from '@rneui/themed';

import CalendarArea from '../areas/CalendarArea';
import { MainModal } from 'components/modal/Modal';

const styles = StyleSheet.create({
  container: {
    width: '50%',
    justifyContent: 'center',
  },
  list: {
    width: '100%',
    backgroundColor: '#000',
  },
  item: {
    width: '50%',
    justifyContent: 'center',
  },
  content: {
    width: '100%',
    justifyContent: 'center',
  },
  imageContent: {
    aspectRatio: 1,
    width: '50%',
    justifyContent: 'center',
  },
  touchContent: {
    width: '100%',
  },
});

interface Props {
  value: string;
  placeholder: string;
  setFieldValue: (data: string) => void;
  availableDates: string[];
  setOtherFieldValues: any;
  style: Record<string, any>;
}

const CalendarDatePicker: React.FC<Props> = ({
  value,
  placeholder,
  setFieldValue,
  availableDates,
  setOtherFieldValues,
  style,
}) => {
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  return (
    <>
      <MainModal
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      >
        {availableDates.length > 0 ? (
          <CalendarArea
            value={value}
            setFieldValue={setFieldValue}
            availableDates={availableDates}
            setOtherFieldValues={setOtherFieldValues}
            style={style}
            onDayPress={() => {
              setIsModalVisible(!isModalVisible);
            }}
          />
        ) : (
          <ActivityIndicator />
        )}
      </MainModal>
      <Chip
        type="outline"
        containerStyle={{ marginVertical: 15 }}
        onPress={() => {
          setIsModalVisible(true);
        }}
      >
        <Text>{value !== '' ? value : placeholder}</Text>
      </Chip>
    </>
  );
};

CalendarDatePicker.defaultProps = {
  value: '',
  style: styles,
};

export default FormField(CalendarDatePicker);
